import { AxiosRequestConfig } from "axios";
import { ApiResponse, apiV1Endpoint } from "../../../../api/v1";
import axios from "../../../../utils/axiosInceptor";
import { Organization, PaymentTypeBase } from "../types";

export async function getOrganizations(config?: AxiosRequestConfig) {
  const url = `${apiV1Endpoint}/organization/list`;

  const response = await axios.get<ApiResponse<Organization[]>>(url, config);
  return response.data.result;
}

type OrganizationResult = Organization & {
  masterPaymentTypes?: PaymentTypeBase[];
};

export async function getOrganizationById(orgId: string, config?: AxiosRequestConfig) {
  const url = `${apiV1Endpoint}/organization/${orgId}`;

  const response = await axios.get<ApiResponse<OrganizationResult>>(url, config);
  return response.data;
}

type PatchOrganizationOptions<TData = unknown> = {
  orgId: string;
  data?: TData;
};

export async function patchOrganization<TData>(options: PatchOrganizationOptions<TData>) {
  const { orgId, data } = options;

  const url = `${apiV1Endpoint}/organization/${orgId}`;

  const response = await axios.patch<ApiResponse>(url, data);
  return response.data;
}
